import { Component, HostListener, OnInit } from '@angular/core'
import { RestServices } from '../../../../../services/rest.services'
import { ModalService } from '../../../../../services/modal.service'
import { AuthService } from '../../../../../services/auth.services'
import * as moment from 'moment'
import { isUndefined, omitBy } from 'lodash'
import { DatepickerHelper } from '../../../../../../helper/datepicker.helper'

@Component({
    selector: 'app-modal-adjustment-aligner',
    templateUrl: './modal-adjustment-aligner.component.html',
    styleUrls: ['../../../../../stagingcss/root-ui-view.component.css', '../../../../../stagingcss/ui-schema-table-form.component.css', '../../../../../stagingcss/lui-select.component.css', './modal-adjustment-aligner.component.css'],
})
export class ModalAdjustmentAlignerComponent implements OnInit {
    // addjustment
    showModalEditAligner = 'hidden'
    en = {}
    showEN = true
    //datepicker
    createDate
    showDate1
    timestampDate
    timestampDateDb
    createDateStart
    showDateStart
    timestampDateStart
    timestampDateStartDb
    optionsLastVisit: any = DatepickerHelper.BASE_OPTIONS

    valueUsage: number = 0
    valueStage: number = 0
    valueInterval: number = 7
    valueWearing: number = 20
    maxPassedAligners: number = 10
    valuePassedAligners: any = 1
    valueNumberofPassed: any = 0
    valueUsageCurent
    elasticTypeLeft
    elasticTypeRight

    hiddenModalUser = 'hidden'
    filterLang: string
    hiddenModalUserStaff = 'hidden'
    showOption
    showOptionStaff
    filterStaff: string
    arrUser
    arrStaff
    optionArrCopy
    valueCreator
    valueStaff
    valueCreatorDeleted
    valueStaffDeleted
    styleVisibility: any
    styleVisibilityStaff: any
    creatorId
    StaffId
    Interval = 'days'
    arrAdjustment
    totalNumber = 0
    // totaPassedAligners;
    arrAlignerParam = {}
    title
    phase
    remark
    arrFlow = {}
    arrNewFlow = {}
    arrDoctor

    changeDate
    changeElasticTypeLeft
    changeElasticTypeRight
    changeInterval
    changeUpdateDate
    changeWearingTime
    statusEdit: number
    cssStage
    oldStage
    oldNextStartDate
    styleModal
    styleModalStaff
    oldInterval
    oldIntervalUnits
    actualUpdateDate


    // insert arr Flow
    buttoncut
    iprCount
    precisioncut
    treatmentOptions
    debug
    statusEsc
    statusEscUser

    constructor(private modalService: ModalService, private authData: AuthService, private restApi: RestServices) {
        this.modalService.changeEmitted$.subscribe(success => {
            if (success) {
                if (success.action === 'activeAdjustment') {
                    this.showModalEditAligner = 'active'
                    this.arrNewFlow = success.sentFlow
                    this.statusEdit = success.indexFlow
                    this.arrFlowEdit(this.arrNewFlow)
                    this.styleModal = { 'left': '4.5em', 'top': '4em' }
                    this.styleModalStaff = { 'top': '5.5em', 'left': '7em' }
                    this.initRange()
                    this.statusEsc = true
                } else if (success === 'editPaddingModalAdjustment') {
                    this.styleModal = { 'left': '7.5em', 'top': '7em' }
                    this.styleModalStaff = { 'top': '9.5em', 'left': '10.5em' }
                    this.statusEsc = true
                }
            }
        })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (this.statusEsc === true) {
            if (keyPressed === 27) {
                event.preventDefault()
                this.statusEsc = false
                this.showModalEditAligner = 'hidden'
                this.modalService.emitChange('statusESC')
            }
        } else if (this.statusEscUser === true) {
            if (keyPressed === 27) {
                event.preventDefault()
                this.statusEsc = true
                this.statusEscUser = false
                this.hiddenModalUser = 'hidden'
            }
        }
    }

    hiddenModalAdjusment() {
        this.statusEsc = false
        this.modalService.emitChange('statusESC')
    }

    ngOnInit() {
        this.listDoctor()
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    arrFlowEdit(arr) {
        this.cssStage = (arr['nextCount'] === 1) ? { 'background-size': '0% 2px' } : { 'background-size': ((arr['nextCount'] - 1) / (arr['lastPassedAlignerNext'] - 1) * 100) + '% 2px' }
        this.valueStage = arr['nextCount']
        this.actualUpdateDate = arr['actualUpdateDate']
        this.oldStage = arr['oldStage']
        this.oldInterval = arr['oldInterval']
        this.oldIntervalUnits = arr['oldIntervalUnits']
        this.oldNextStartDate = moment(arr['oldNextStartDate']).utc().startOf('day').valueOf()
        this.createDate = moment(arr['updateDate'])
        this.createDateStart = moment(arr['nextStartDate'])
        this.valueInterval = arr['interval']
        this.Interval = arr['intervalUnit']
        this.elasticTypeLeft = arr['elasticTypeLeft']
        this.elasticTypeRight = arr['elasticTypeRight']
        this.creatorId = arr['doctor']
        this.StaffId = arr['staff']
        this.remark = arr['remark']
        this.changeDate = arr['changeDate']
        this.changeElasticTypeLeft = arr['changeElasticTypeLeft']
        this.changeElasticTypeRight = arr['changeElasticTypeRight']
        this.changeInterval = arr['changeInterval']
        this.changeUpdateDate = arr['changeUpdateDate']
        this.changeWearingTime = arr['changeWearingTime']
        this.valueWearing = arr['wearingTime']
        this.totalNumber = arr['totalNumber']
        this.title = arr['title']
        this.phase = arr['phase']
        this.buttoncut = arr['buttoncut']
        this.iprCount = arr['iprCount']
        this.precisioncut = arr['precisioncut']
        this.treatmentOptions = arr['treatmentOptions']
        this.debug = arr['debug']
        this.valuePassedAligners = arr['passedAlignerFrom'] ? arr['passedAlignerFrom'] : arr['lastPassedAlignerNext']
        this.valueNumberofPassed = arr['passedAligners'] ? arr['passedAligners'] : 0
        if (arr['passedAlignerFrom'] > this.totalNumber) {
            this.valuePassedAligners = this.totalNumber
        }
        for (let i = 0; i <= this.arrDoctor.length; i++) {
            if (this.arrDoctor[i] && this.arrDoctor[i]['_id'] === this.creatorId) {
                this.valueCreator = (this.arrDoctor[i].firstName || '') + ' ' + (this.arrDoctor[i].familyName || '')
                this.valueCreatorDeleted = this.arrDoctor[i].deleted
                this.showOption = 'showOption_' + this.creatorId
                this.styleVisibility = { visibility: 'visible' }
            } else if (this.creatorId === undefined) {
                this.valueCreator = ''
                this.valueCreatorDeleted = undefined
                this.showOption = undefined
            }
            if (this.arrDoctor[i] && this.arrDoctor[i]['_id'] === this.StaffId) {
                this.valueStaff = (this.arrDoctor[i].firstName || '') + ' ' + (this.arrDoctor[i].familyName || '')
                this.valueStaffDeleted = this.arrDoctor[i].deleted
                this.showOptionStaff = 'showOptionStaff_' + this.StaffId
                this.styleVisibilityStaff = { visibility: 'visible' }
            } else if (this.StaffId === undefined) {
                this.valueStaff = ''
                this.valueStaffDeleted = undefined
                this.showOptionStaff = undefined

            }
        }
        $('.rangeNumberOfPassed ons-range').attr('max', this.totalNumber - this.valuePassedAligners + 1)
        $('.rangePassAligner ons-range').attr('max', this.totalNumber)
        $('.rangeUsageInput ons-range').attr('max', this.totalNumber)
    }

    initRange() {
        const rangeStage = parseInt(this.arrNewFlow['lastPassedAlignerNext']) > this.totalNumber ? this.totalNumber : parseInt(this.arrNewFlow['lastPassedAlignerNext'])
        $('.rangeStage ons-range').attr('max', rangeStage)
    }

    listDoctor() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrDoctor = success['response']['staff']['paths']['{}']                
            })
        })
    }

    //************************************************** ADJUSTMENT **************************************************************************//

    showDate(event, action) {
        if (action == 'updateDate') {
            this.changeUpdateDate = true
        } else {
            this.changeDate = true
        }
        let offsetTimezone = new Date().getTimezoneOffset()
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).startOf('day').valueOf()

            if (action === 'updateDate') {
                this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
                this.timestampDate = timestamp
                this.timestampDateDb = moment(setTimestamp).utc().startOf('day').valueOf()
                // this.createDate = moment(timestamp);
            } else if (action === 'startDate') {
                this.timestampDateStart = timestamp
                this.timestampDateStartDb = moment(setTimestamp).utc().startOf('day').valueOf()
                this.showDateStart = moment(timestamp).format('YYYY.MM.DD ddd')
                // this.createDateStart = moment(timestamp);
            }
        } else {
            const timestamp = moment(Date.now()).utc().startOf('day').valueOf()
            this.showDate1 = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.showDateStart = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDateDb = timestamp
            this.timestampDateStartDb = timestamp
        }
    }

    nextDate(timestampAdd, day, action) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').add(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        if (action === 'startDate') {
            this.timestampDateStart = timestampDate
            this.timestampDateStartDb = timestampDateDb
            this.showDateStart = showdateAdd
            this.createDateStart = moment(timestampDate)
            this.changeDate = true
        } else if (action === 'updateDate') {
            this.timestampDate = timestampDate
            this.timestampDateDb = timestampDateDb
            this.showDate1 = showdateAdd
            this.createDate = moment(timestampDate)
            this.changeUpdateDate = true
        }
    }

    prevDate(timestampAdd, day, action) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').subtract(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        if (action === 'startDate') {
            this.timestampDateStart = timestampDate
            this.timestampDateStartDb = timestampDateDb
            this.showDateStart = showdateAdd
            this.createDateStart = moment(timestampDate)
            this.changeDate = true
        } else if (action === 'updateDate') {
            this.timestampDate = timestampDate
            this.timestampDateDb = timestampDateDb
            this.showDate1 = showdateAdd
            this.createDate = moment(timestampDate)
            this.changeUpdateDate = true
        }
    }

    prevUsage(valueUsageCurent, day, attribute) {
        if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
            this.valueUsage = parseInt(valueUsageCurent) - parseInt(day)
        } else {
            this.valueUsage = 0
        }
        if (attribute === 'Stage') {
            if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
                this.valueStage = parseInt(valueUsageCurent) - parseInt(day)
            } else {
                this.valueStage = parseInt(this.arrNewFlow['lastPassedAlignerNext'])
            }
        } else if (attribute === 'Interval') {
            if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
                this.valueInterval = parseInt(valueUsageCurent) - parseInt(day)
            } else {
                this.valueInterval = 0
            }

        } else if (attribute === 'Wearing') {
            if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
                this.valueWearing = parseInt(valueUsageCurent) - parseInt(day)
            } else {
                this.valueWearing = 0
            }
        } else if (attribute === 'NumberofPassed') {
            if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
                this.valueNumberofPassed = parseInt(valueUsageCurent) - parseInt(day)
            } else {
                this.valueNumberofPassed = 0
            }
        } else if (attribute === 'PassedAligners') {
            if (parseInt(valueUsageCurent) > 0 && parseInt(valueUsageCurent) - parseInt(day) > 0) {
                this.valuePassedAligners = parseInt(valueUsageCurent) - parseInt(day)
            } else {
                this.valuePassedAligners = 0
            }
        }
        // this[`value${attribute}`] = this.valueUsage;

        if (attribute === 'PassedAligners') {
            this.changevalueUsage(this.valuePassedAligners, 'PassedAligners')
        }
    }

    nextUsage(valueUsageCurent, day, attribute) {

        if (attribute === 'PassedAligners') {
            this.changevalueUsage(this.valuePassedAligners, 'PassedAligners')
            if (parseInt(valueUsageCurent) + parseInt(day) <= this.totalNumber) {
                this.valuePassedAligners = parseInt(valueUsageCurent) + parseInt(day)
            } else {
                this.valuePassedAligners = this.totalNumber
            }
        } else if (attribute === 'Stage') {
            if (parseInt(valueUsageCurent) < parseInt(this.arrNewFlow['lastPassedAlignerNext']) && parseInt(valueUsageCurent) + parseInt(day) <= parseInt(this.arrNewFlow['lastPassedAlignerNext'])) {
                this.valueStage = parseInt(valueUsageCurent) + parseInt(day)
            } else {
                this.valueStage = parseInt(this.arrNewFlow['lastPassedAlignerNext']) > this.totalNumber ? this.totalNumber : parseInt(this.arrNewFlow['lastPassedAlignerNext'])
            }
        } else if (attribute === 'Interval') {
            if (this.valueInterval <= 21 && parseInt(valueUsageCurent) + parseInt(day) <= 21) {
                this.valueInterval = parseInt(valueUsageCurent) + parseInt(day)
            } else {
                this.valueInterval = 21
            }

        } else if (attribute === 'Wearing') {
            if (this.valueWearing <= 24 && parseInt(valueUsageCurent) + parseInt(day) <= 24) {
                this.valueWearing = parseInt(valueUsageCurent) + parseInt(day)
            } else {
                this.valueWearing = 24
            }
        } else if (attribute === 'NumberofPassed') {
            if ((parseInt(valueUsageCurent) + parseInt(day)) <= (this.totalNumber - this.valuePassedAligners + 1)) {
                this.valueNumberofPassed = parseInt(valueUsageCurent) + parseInt(day)
            } else {
                this.valueNumberofPassed = this.totalNumber - this.valuePassedAligners + 1
            }
        }
    }

    changevalueUsage(valueStageChange, action) {
        if (valueStageChange) {
            switch (action) {
                case 'PassedAligners':
                    const AlignerNumberofPassed = this.totalNumber - this.valuePassedAligners + 1
                    this.valueNumberofPassed = (AlignerNumberofPassed < this.valueNumberofPassed) ? AlignerNumberofPassed : this.valueNumberofPassed
                    $('.rangeNumberOfPassed ons-range').attr('max', this.totalNumber - this.valuePassedAligners + 1)
                    break
                case 'Stage':
                    const rangeStage = parseInt(this.arrNewFlow['lastPassedAlignerNext']) > this.totalNumber ? this.totalNumber : parseInt(this.arrNewFlow['lastPassedAlignerNext'])
                    $('.rangeStage ons-range').attr('max', rangeStage)
                    // this.valueUsageCurent = this.valueInterval = parseInt(valueUsageChange);
                    break
            }
        } else {
            this.valueUsageCurent = this.valueStage = 0
        }
    }

    showModalUser(action) {
        this.statusEsc = false
        this.statusEscUser = true
        if (action === 'doctor') {
            this.listUser()
            this.hiddenModalUser = 'active'
        } else if (action === 'staff') {
            this.listStaff()
            this.hiddenModalUserStaff = 'active'
        }
    }

    // get list user
    listUser() {
        this.hiddenModalUser = 'active'
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrUser = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrUser.slice() // copy of optionArr
                if (this.arrUser) {
                    this.arrUser.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    // close modal
    closeModal(action, index) {
        if (action == 'save') {
            const countAlignerTo = (this.valueNumberofPassed * 1) + (this.valuePassedAligners * 1) - 1
            let AglinerTo
            // check aligner to
            if (this.valueNumberofPassed > 0) {
                if (this.totalNumber <= countAlignerTo) {
                    AglinerTo = this.totalNumber
                } else if (this.arrNewFlow['lastPassedAlignerCount'] === this.arrNewFlow['passedAlignerTo']) {
                    AglinerTo = countAlignerTo
                } else {
                    AglinerTo = countAlignerTo
                }
            } else if (this.valueNumberofPassed <= 0 && this.arrNewFlow['lastPassedAlignerNext'] <= this.totalNumber) {
                AglinerTo = this.arrNewFlow['lastPassedAlignerCount']
            }

            this.arrFlow = {
                debug: this.arrNewFlow['debug'],
                abort: (this.Interval === 'abort') ? true : false,
                actualUpdateDate: this.actualUpdateDate,
                changeDate: this.changeDate,
                changeElasticTypeLeft: this.changeElasticTypeLeft,
                changeElasticTypeRight: this.changeElasticTypeRight,
                changeInterval: this.changeInterval,
                changeUpdateDate: this.changeUpdateDate,
                changeWearingTime: this.changeWearingTime,
                elasticTypeLeft: this.elasticTypeLeft,
                elasticTypeRight: this.elasticTypeRight,
                endDate: this.timestampDateStartDb + (this.totalNumber * this.valueInterval * 86400000),
                interval: this.valueInterval,
                intervalUnit: this.Interval,
                phase: this.phase,
                startDate: this.timestampDateStartDb,
                status: 'active',
                title: this.title,
                updateDate: this.timestampDateDb,
                wearingTime: this.valueWearing,
                doctor: this.creatorId,
                flowSettingMode: 'nextStage',
                isFirst: true,
                nextCount: Number(this.valueStage),
                oldStage: this.oldStage,
                nextStartDate: this.timestampDateStartDb,
                passedAlignerFrom: this.valuePassedAligners * 1,
                passedAlignerTo: Number(AglinerTo) || 0,
                passedAligners: this.valueNumberofPassed * 1,
                remark: this.remark,
                staff: this.StaffId,
                totalNumber: Number(this.totalNumber),
            }
            const data = {
                'action': 'initialStages', 'flowInfo': omitBy(this.arrFlow, isUndefined), 'flowIndex': this.statusEdit,
            }
            this.modalService.emitChange(data)
            this.showModalEditAligner = 'hidden'
            this.resetModal()
        }
        if (action == 'remove') {
            const data = {
                'action': 'removeStage', 'index': this.statusEdit, 'nextCount': Number(this.valueStage),
            }
            this.modalService.emitChange(data)
            this.showModalEditAligner = 'hidden'
            this.resetModal()
        }

    }

    // reset modal
    resetModal() {
        this.valueCreator = undefined
        this.valueStaff = undefined
        this.valueCreatorDeleted = undefined
        this.valueStaffDeleted = undefined
    }

    hidenModal() {
        this.hiddenModalUser = 'hidden'
        this.hiddenModalUserStaff = 'hidden'
    }

    listStaff() {
        this.hiddenModalUserStaff = 'active'
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrStaff = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrStaff.slice() // copy of optionArr
                if (this.arrStaff) {
                    this.arrStaff.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    selectOption(id, value) {
        this.showOption = 'showOption_' + id
        if (this.showOption) {
            this.valueCreator = value
            this.valueCreatorDeleted = undefined
            this.creatorId = id
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModal()
        }
    }

    // search language
    searchStaff(): void {
        const term = this.filterStaff
        this.arrStaff = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    selectOptionStaff(id, value) {
        this.showOptionStaff = 'showOptionStaff_' + id
        if (this.showOptionStaff) {
            this.valueStaff = value
            this.valueStaffDeleted = undefined
            this.StaffId = id
            this.styleVisibilityStaff = { visibility: 'visible' }
            this.hidenModal()
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.arrUser = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/aligner/modal-adjustment-aligner/modal-adjustment-aligner.component.ts